import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';

import { serverRequest } from "../../util/server_request";
import { extractErrorMessage } from '../extractErrorMessage';
import { notifyUser } from '../../util/util';

const notifiedErrors = new Set();

// Helper function to notify only once for the same error
const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

// Fetches all corporate accounts from /all-corporate-accounts endpoint using React Query
export function usePensionsSummary() {
  return useQuery({
    queryKey: ['pensions-summary'],
    queryFn: async () => {
      try {
        const result = await serverRequest('GET', 'pensions-summary');
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to fetch pensions summary');
        }
        return result;
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to fetch pensions summary');
        notifyOnce("error", errorMessage, "Error");
        throw new Error(errorMessage);
      }
    },
    enabled: !!secureLocalStorage.getItem('token'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
